import { MAP_LAYER_IDS } from '../../lib/constants'

export default (dispatch) => {
	const setVisibleFeatureGraphics = (visible, hasSidebarView) => {
		let dispatchParams = null
		if (visible.all) {
			dispatchParams = {
				type: 'map/setAllFeatureGraphicsVisibility',
				payload: {
					layerId: MAP_LAYER_IDS.content,
					visibility: true,
				},
			}
		} else {
			dispatchParams = {
				type: 'map/setFeatureGraphicsVisibilityById',
				payload: {
					featureIds: visible.features,
					layerId: MAP_LAYER_IDS.content,
					visibility: true,
				},
			}
		}
		
		dispatch({
			type: 'toast/dismiss'
		});
		if (hasSidebarView) {
			dispatch({
				type: 'app/setShowSidebar',
				payload: true,
			})
		}
		dispatch({
			type: 'map/setIsChangingMapMode',
			payload: false,
		})
		dispatch({
			...dispatchParams,
			callback: () => {
				setTimeout(() => {
					dispatch({
						type: 'features/setFeaturesLoading',
						payload: false,
					})
					dispatch({
						type: 'features/setCollectionsLoading',
						payload: false,
					})
				}, 125)
			},
		})
	}
	return {
		completeMapChange: (featuresCount, visible, hasSidebarView) => {
			let timeout = visible.all ? featuresCount : visible.features.length
			if (timeout > 2500) timeout = 2500
			setTimeout(() => {
				setVisibleFeatureGraphics(visible, hasSidebarView)
			}, timeout)
		},
	}
}
